import { EllipsisVerticalIcon } from 'lucide-react'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'twyne-new.ui'

export default function TemplateActions({ setIsEditing, onRemove }) {
  return <>
    <DropdownMenu>
      <DropdownMenuTrigger>
        <EllipsisVerticalIcon size={16} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start' className='p-2' container='#theme-provider'>
        <DropdownMenuItem onClick={() => setIsEditing(true)}>
          Rename
        </DropdownMenuItem>
        <DropdownMenuItem>
          Duplicate
        </DropdownMenuItem>
        <DropdownMenuItem className='twy-text-danger' onClick={onRemove}>
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </>
}
